module.exports = __webpack_public_path__ + "img/logout_disabled.svg";